import { useCallback } from 'react'

import { useAsync } from 'core/ui/hooks/useAsync'

import { getRfpHistory } from '../../use-cases/getRfpHistory'

export function useProposalHistory() {
  const { call, result, status } = useAsync(getRfpHistory)

  const fetchRfpHistory = useCallback(
    async ({ signal }: AbortController) => call({ signal }),
    [call]
  )

  return {
    rfpHistory: result ?? [],
    rfpHistoryStatus: status,
    fetchRfpHistory,
  }
}
